import { MessageFormatElement } from 'react-intl';
import { AppLocale } from '../constants';

export class IntlService {
  public static get DefaultLocale() {
    return AppLocale.English;
  }

  public static get UserLocale() {
    return navigator.language.substring(0, 2) as AppLocale;
  }

  public static get UserLocaleRaw() {
    return navigator.language;
  }

  /*
    This method is available to provide translation message to
    IntlProvider only and should not be used directly.
  */
  public static LoadLanguage = (localLang: AppLocale) => {
    let lang = localLang;

    if (!IntlService.supportedLanguages.includes(lang)) {
      lang = IntlService.DefaultLocale;
    }

    return import(`../translations/${lang}.json`);
  };

  private static supportedLanguages = [IntlService.DefaultLocale, AppLocale.Spanish];
}

// eslint-disable-next-line max-len
export type MessagesType = Record<string, string> | Record<string, MessageFormatElement[]> | undefined;
